import { render, staticRenderFns } from "./form_edit.vue?vue&type=template&id=2547afe3&scoped=true&"
import script from "./form_edit.vue?vue&type=script&lang=js&"
export * from "./form_edit.vue?vue&type=script&lang=js&"
import style0 from "./form_edit.vue?vue&type=style&index=0&id=2547afe3&scoped=true&lang=css&"
import style1 from "./form_edit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2547afe3",
  null
  
)

export default component.exports